<div [formGroup]="form" class="item-holder">
  <label class="k-label master-label"  [hidden]="!param.showMasterLabel">{{param.label}}</label>
  <div [ngSwitch]="param.controlType">
    <kendo-floatinglabel  *ngSwitchCase="'textbox'"  [text]="param.label">
    <kendo-textbox class="textbox-full" [formControlName]="param.key"
                   [id]="param.key" [(value)]="param.value"  ></kendo-textbox>
    </kendo-floatinglabel>
    <kendo-floatinglabel  *ngSwitchCase="'datefield'"  [text]="param.label">
    <kendo-datepicker  [id]="param.key"  [format]="param.format"  [formControlName]="param.key"
      [(value)]="param.value"
    ></kendo-datepicker>
    </kendo-floatinglabel>
    <app-date-range [id]="param.key" *ngSwitchCase="'daterangefield'" [param]="param" [formControlName]="param.key"  ></app-date-range>

    <app-chain-select [id]="param.key" *ngSwitchCase="'chainselectfield'" [formControlName]="param.key" [(ngModel)]="param.value"  ></app-chain-select>

    <kendo-floatinglabel  *ngSwitchCase="'dropdown'"  [text]="param.label">
    <kendo-dropdownlist class="dropdown-full" [id]="param.key" [formControlName]="param.key" [data]="param.dropdownOptions" [(ngModel)]="param.value"></kendo-dropdownlist>
    </kendo-floatinglabel>

    <kendo-floatinglabel  *ngSwitchDefault  [text]="param.label">
    <kendo-textbox class="textbox-full" *ngSwitchDefault [formControlName]="param.key"
                   [id]="param.key"  ></kendo-textbox>
    </kendo-floatinglabel>

  </div>
  <div class="errorMessage" *ngIf="!isValid"><p class="errorp">{{param.label}} is required</p></div>
</div>
